<template>
  <v-layout row wrap>
    <v-flex xs12 sm2 md2>
      <v-select
        v-model="pagination.rowsPerPage"
        :items="rowsPerPage"
        item-text="name"
        item-value="value"
        label="Rows per page"
        v-show="!hideRowsPerPage"
      ></v-select>
    </v-flex>
    <v-flex xs12 sm10 md10>
      <div class="text-xs-center text-sm-right pt-3 xs-py-0" v-show="showPager">
        <v-pagination v-model="pagination.page" :length="pages" :total-visible="$store.state.metadata.windowWidth > 600 ? 7 : 5"></v-pagination>
      </div>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  name: 'ToolbarPagerComponent',
  props: ['pagination', 'hideRowsPerPage', 'rowsPerPageSelect'],
  data () {
    return {
      size: null,
      rowsPerPage: [
        { name: '25', value: 25 },
        { name: '50', value: 50 },
        { name: '100', value: 100 },
        { name: '200', value: 200 }
      ]
    }
  },
  computed: {
    pages () {
      if (this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      ) return 0

      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
    },
    showPager () {
      if (this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null ||
        Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage) < 1
      ) return false

      return true
    }
  },
  watch: {
    'pagination.rowsPerPage': {
      handler () {
        this.pagination.page = 1
      }
    }
  },
  mounted () {
    if (this.rowsPerPageSelect) this.rowsPerPage = this.rowsPerPageSelect
    this.pagination.rowsPerPage = this.pagination.rowsPerPage ? this.pagination.rowsPerPage : 25
  }
}
</script>



// WEBPACK FOOTER //
// src/components/toolbar-pager/ToolbarPagerComponent.vue